import axios from "axios";

export const GET_ALL_MP = "GET_ALL_MP";

export const getAllMP = () => {
  return async (dispatch) => {
    return await axios
      .get(process.env.REACT_APP_SERVER_URL + `/api/matiere/get/all`)
      .then((res) => {
        dispatch({ type: GET_ALL_MP, payload: res.data });
      })
      .catch((err) => console.log(err));
  };
};
